import { actionNameGenerator } from "../../../../utils/commonUtil";

const domainPrefix = "id";
const idActionNameGenerator = actionNameGenerator(domainPrefix);

export const accountDataRequestFailedType = idActionNameGenerator("accountDataRequestFailed");
export const investmentDashboardDataSuccessType = idActionNameGenerator("investmentDashboardDataSuccess");
export const investmentDashboardDataLoaderType = idActionNameGenerator("investmentDashboardDataLoader");
export const investmentDashboardSuccessType = idActionNameGenerator("investmentDashboardSuccess");
export const recentExchangeDataSuccessType = idActionNameGenerator("recentExchangeDataSuccess");
export const recentExchangeDataLoaderType = idActionNameGenerator("recentExchangeDataLoader");
export const recentDataRequestFailedType = idActionNameGenerator("recentDataRequestFailed");
export const recurringExchangeDataSucessType = idActionNameGenerator("recurringExchangeDataSucess");
export const recurringExchangeDataLoaderType = idActionNameGenerator("recurringExchangeDataLoader");
export const recurringDataRequestFailedType = idActionNameGenerator("recurringDataRequestFailedType");

